import $ from "jquery";
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "contactDetail")
        return;
});
//# sourceMappingURL=contactDetail.js.map